// Saturated colors
// export enum ChartColors {
//     ORANGE = '#FF9800',
//     RED = '#F44336',
//     BLUE = '#2196F3',
//     GREEN = '#4CAF50',
//     YELLOW = '#F5C242',
//     PURPLE = '#9C27B0',
//     TEAL = '#009688',
//     PINK = '#E91E63',
//     INDIGO = '#3F51B5'
// }

export enum ChartColors {
    ORANGE = '#FFB74D',
    RED = '#E57373',
    BLUE = '#64B5F6',
    GREEN = '#81C784',
    YELLOW = '#FFCA28',
    PURPLE = '#CE93D8',
    TEAL = '#80CBC4',
    PINK = '#F48FB1',
    INDIGO = '#9FA8DA'
}
